module.exports = __webpack_public_path__ + "img/bannar1.1279d685.png";